import throttle from '~/utils/throttle';

const ReturnTop = ((DM) => {

    const CONTAINER_SELECTOR = '.js-page-wrap';
    const THRESHOLD = 100;
    const THROTTLE = 100;

    const ClassNames = {
        ACTIVE: 'is-active',
        INACTIVE: 'is-inactive'
    };

    const TEMPLATE = `
        <button class="dml-page-return" title="Przewiń stronę do góry" aria-label="Przewiń stronę do góry">
            <svg viewBox="0 0 32 32" width="32" height="32">
                <use xlink:href="/assets/symbols/icons.svg?v=${DM.Config.IconsSetVersion}#im-angle-up"></use>
            </svg>
        </button>`;

    class ReturnTop {
        constructor() {
            this.show = false;
            this.currentScroll = 0;
            this.offset = window.innerHeight;
            this.element = this.createElement(TEMPLATE);
            this.container = document.querySelector(CONTAINER_SELECTOR);
            this.appendElement(this.element, this.container);
        }

        /**
         * @param {HTMLElement} element
         * @param {HTMLElement} container = default value document.body
         */
        appendElement(element, container = document.body) {
            window.requestAnimationFrame(() => {
                container.appendChild(element);
                window.addEventListener('scroll', throttle(this.handleScroll.bind(this), THROTTLE), {
                    passive: true,
                    capture: false
                });
                element.addEventListener('click', this.handleClick.bind(this), false);
            });
        }

        /**
         * @param {String} html
         * @returns {HTMLElement}
         */
        createElement(html) {
            const element = document.createElement('div');
            element.innerHTML = html.trim();
            return element.firstChild;
        }

        /**
         * @param {HTMLElement} element
         * @param {Boolean} show
         */
        render() {
            window.requestAnimationFrame(() => {
                this.element.classList.toggle(ClassNames.ACTIVE, this.show);
                this.element.classList.toggle(ClassNames.INACTIVE, !this.show);
                this.currentScroll = window.pageYOffset;
            });
        }

        /**
         * @param {Event} event
         */
        handleScroll() {
            const last = this.currentScroll;
            const position = window.pageYOffset;

            if (position > this.offset) {
                if (position < last - THRESHOLD) {
                    this.show = true;
                    this.render();
                } else if (position > last + THRESHOLD) {
                    this.show = false;
                    this.render();
                }
            } else {
                this.show = false;
                this.render();
            }
        }

        /**
        * @param {Event} event
        */

        handleClick(event) {
            event.preventDefault();

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            DM.Utils.trackEvents('button_top', 'click');
        }
    }

    return new ReturnTop();

})(window.DM);

export default ReturnTop;
